import i18n from 'vl-common/src/lib/i18n';
import React, { forwardRef } from 'react';
import { Input, type InputProps, InputRef } from 'antd';
import { sanitiseValueFromAngleBrackets } from 'vl-common/src/utils';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';

const t = i18n.getFixedT(null, 'main');

export const LastNameFormItem = forwardRef<InputRef, RegistrationFormItemProps & { inputProps?: InputProps }>(
  ({ inputProps, ...props }, ref) => (
    <RegistrationFormItem
      normalize={sanitiseValueFromAngleBrackets}
      name="last_name"
      label={t('Last name')}
      required
      rules={[{ required: true, message: 'Last name is required' }]}
      {...props}
    >
      <Input type="text" data-testid="lastname" autoComplete="family-name" ref={ref} {...inputProps} />
    </RegistrationFormItem>
  )
);
